<ul *ngIf="resultsOfSearch?.length > 0" class="wb-search-results-list list-unstyled">
  <li (click)="selectResult(result)" *ngFor="let result of resultsOfSearch">
    {{ result.displayName }}
  </li>
</ul>
